import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fb_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e, fallback = "Algo salió mal. Intenta de nuevo.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export async function streamChat(path, body, onDelta, onDone, onActions) {
  const headers = { "Content-Type": "application/json" };
  const t = localStorage.getItem("fb_token");
  if (t) headers.Authorization = `Bearer ${t}`;
  const res = await fetch(`${API}${path}`, { method: "POST", headers, credentials: "include", body: JSON.stringify(body) });
  if (!res.ok) {
    let detail = "Error de IA";
    try { detail = (await res.json()).detail || detail; } catch (_) {}
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const j = JSON.parse(p.slice(6));
      if (j.delta) onDelta(j.delta);
      if (j.error) onDelta(`⚠️ ${j.error}`);
      if (j.actions) onActions?.(j.actions);
      if (j.done) onDone?.(j);
    }
  }
}
